module.exports = __webpack_public_path__ + "img/3.3b9d10a5.png";